import { render, staticRenderFns } from "./SelectButton.vue?vue&type=template&id=3c45b856&"
import script from "./SelectButton.vue?vue&type=script&lang=js&"
export * from "./SelectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports